import React from 'react'
import { connect } from 'react-redux'

const IdPhase = (props) => (
  <div>
    <div className='ibox-title'>
      <h5>Phase</h5>
    </div>
    <div className='ibox-content text-center text-uppercase'>
      <span className='bg-success p-xs' style={{ cursor: 'default' }}>
        {props.currentPhase || 'N/A'}
      </span>
    </div>
  </div>
)

const mapStateToProps = (state) => ({
  isFetching: state.txById.isFetching,
})

export default connect(mapStateToProps)(IdPhase)
